import ReactDOM from 'react-dom/client';
import { App } from './app';

import '@insight-health-ai/roseate/styles/index.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />
);
